export const REDUCER_NAME="fbAdsetSlice";
// ==========================
// Create AdSet DTO
// ==========================

export interface IFacebookAdsetCreateDTO {
  name: string;
  campaign_id: string;
  daily_budget: string;  // must be numeric string
  billing_event: "IMPRESSIONS" | "LINK_CLICKS" | "APP_INSTALLS";
  optimization_goal:
    | "LEAD_GENERATION"
    | "REACH"
    | "IMPRESSIONS"
    | "LINK_CLICKS";
  bid_strategy:
    | "LOWEST_COST_WITHOUT_CAP"
    | "LOWEST_COST_WITH_BID_CAP"
    | "COST_CAP";
}

// ==========================
// AdSet Response DTO
// ==========================

export interface IFacebookAdsetDTO {
  id: string;
  name?: string;
  status?: "ACTIVE" | "PAUSED" | "DELETED";
  campaign_id?: string;
  daily_budget?: string;
  optimization_goal?: string;
  billing_event?: string;
  bid_strategy?: string;
  created_time?: string;
}

// ==========================
// AdSet Redux State
// ==========================

export interface IFacebookAdsetState {
  facebookAdsetList: IFacebookAdsetDTO[] | null;
  isLoading: boolean;
  errorMessage: string | null;
}
